"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recursiveTypeCast = exports.iterator = void 0;
var mappers = {
  toJSON: {
    uint32: function uint32(value) {
      return value;
    },
    sint32: function sint32(value) {
      return value;
    },
    uint64: function uint64(value) {
      return value.toString();
    },
    sint64: function sint64(value) {
      return value.toString();
    },
    string: function string(value) {
      return value;
    },
    bytes: function bytes(value) {
      return value.toString('hex');
    },
    boolean: function boolean(value) {
      return value;
    }
  },
  fromJSON: {
    uint32: function uint32(value) {
      return value;
    },
    sint32: function sint32(value) {
      return value;
    },
    uint64: function uint64(value) {
      return BigInt(value);
    },
    sint64: function sint64(value) {
      return BigInt(value);
    },
    string: function string(value) {
      return value;
    },
    bytes: function bytes(value) {
      return Buffer.from(value, 'hex');
    },
    boolean: function boolean(value) {
      return value;
    }
  }
};

var findObjectByPath = function findObjectByPath(message, pathArr) {
  var result = message;

  for (var i = 0; i < pathArr.length; i += 1) {
    if (!result.properties && !result.items) {
      return undefined;
    }

    if (result.properties) {
      result = result.properties[pathArr[i]];
    } else if (result.items) {
      var x = result.items.properties;
      result = x[pathArr[i]];
    }
  }

  return result;
};

var isObject = function isObject(item) {
  return typeof item === 'object' && item !== null && !Array.isArray(item) && !Buffer.isBuffer(item);
};

var iterator = function iterator() {
  var _this = this;

  var index = 0;
  var properties = Object.keys(this);
  var Done = false;
  return {
    next: function next() {
      Done = index >= properties.length;
      var obj = {
        done: Done,
        value: {
          value: _this[properties[index]],
          key: properties[index]
        }
      };
      index += 1;
      return obj;
    }
  };
};

exports.iterator = iterator;

var recursiveTypeCast = function recursiveTypeCast(mode, object, schema, dataPath) {
  var _a;

  var _iterator = _createForOfIteratorHelper(object),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          key = _step$value.key,
          value = _step$value.value;

      if (isObject(value)) {
        dataPath.push(key);
        value[Symbol.iterator] = exports.iterator;
        exports.recursiveTypeCast(mode, value, schema, dataPath);
        dataPath.pop();
        delete value[Symbol.iterator];
      } else if (Array.isArray(value)) {
        dataPath.push(key);
        var schemaProp = findObjectByPath(schema, dataPath);

        if (((_a = schemaProp === null || schemaProp === void 0 ? void 0 : schemaProp.items) === null || _a === void 0 ? void 0 : _a.type) === 'object') {
          for (var i = 0; i < value.length; i += 1) {
            var arrayObject = value[i];
            arrayObject[Symbol.iterator] = exports.iterator;
            exports.recursiveTypeCast(mode, arrayObject, schema, dataPath);
            delete arrayObject[Symbol.iterator];
          }
        } else {
          for (var _i = 0; _i < value.length; _i += 1) {
            if (schemaProp === undefined || schemaProp.items === undefined) {
              throw new Error("Invalid schema property found. Path: ".concat(dataPath.join(',')));
            }

            object[key][_i] = mappers[mode][schemaProp.items.dataType](value[_i]);
          }
        }

        dataPath.pop();
      } else {
        dataPath.push(key);

        var _schemaProp = findObjectByPath(schema, dataPath);

        if (_schemaProp === undefined) {
          throw new Error("Invalid schema property found. Path: ".concat(dataPath.join(',')));
        }

        object[key] = mappers[mode][_schemaProp.dataType](value);
        delete object[Symbol.iterator];
        dataPath.pop();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  delete object[Symbol.iterator];
};

exports.recursiveTypeCast = recursiveTypeCast;